// extracted by mini-css-extract-plugin
export default {"hiddenCover":"purchase-preview_hiddenCover__iLeqo","shown":"purchase-preview_shown__A73sc","preview":"purchase-preview_preview__9hPlM"};